import {LitElement, html, PropertyValues} from "lit";
import { customElement, state } from "lit/decorators.js";
import '@/components/cookie-overlay/cookie-overlay';
import { style } from './datawrapper.styles';

@customElement('sbk-datawrapper')
export class Datawrapper extends LitElement {

    @state()
    thirdParty = false;

    static get styles() {
        return style;
    }

    firstUpdated() {
        this.addEventListener('third-party-cookies-accepted', () => {
            this.checkCookies();
        });
    }

    willUpdate(changedProperties: PropertyValues<this>) {
        if (changedProperties.has('thirdParty')) {
            this.handleChange();
        }
    }

    connectedCallback() {
        super.connectedCallback();
        this.checkCookies();
    }

    checkCookies() {
        const cookies = JSON.parse(decodeURIComponent(document.cookie.replace(/(?:(?:^|.*;\s*)cookie-optIn\s*=\s*([^;]*).*$)|^.*$/, '$1')) || '{}');
        this.thirdParty = cookies.thirdParty || false;
    }

    render() {
        return html`<div class="wrapper">
            ${this.thirdParty ? html`<slot name="datawrapper" @slotchange=${this.handleChange}></slot>` : html`<sbk-cookie-overlay></sbk-cookie-overlay>`}
        </div>`;
    }

    handleChange() {
        const observedNodes = new Set();
        const targetParent = this.querySelector('div[slot="datawrapper"]');

        if (targetParent) {
            const observer = new MutationObserver((mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach((node) => {
                            if ((node as Element).tagName.startsWith('DATAWRAPPER-VISUALIZATION')) {
                                if (!observedNodes.has(node)) {
                                    this.injectStyles((node as HTMLElement).shadowRoot);
                                    observedNodes.add(node);
                                }
                            }
                        });
                    }
                }
            });

            observer.observe(targetParent, { childList: true, subtree: true });
        }
    }

    injectStyles(shadowRoot: ShadowRoot | null) {
        if (shadowRoot) {
            const styleElement = document.createElement('style');
            styleElement.className = 'sbk'
            styleElement.textContent = `
                div {
                    font-family: var(--sbkCoreFontFamily) !important;
                    color: var(--sbkColorContentFgColorOnLightDefault) !important;
                }
                h3 {
                    color: var(--sbkColorContentFgColorOnLightDefault) !important;
                }
                p.block-description, .legend {
                    color: var(--sbkColorContentFgColorOnLightDefault);
                    font-family: var(--sbkCoreFontFamily);
                    font: var(--sbkTypographyContentSmallScrBodyRegularMd);
                    font-weight: var(--sbkCoreFontWeightNormal);
                    -moz-osx-font-smoothing: grayscale;
                    -webkit-font-smoothing: antialiased;
                }

                .label {
                    color: var(--sbkColorContentFgColorOnLightDefault);
                    font-family: var(--sbkCoreFontFamily);
                    font: var(--sbkTypographyContentSmallScrBodyRegularXs);
                    @media all and (min-width: 992px) {
                        font: var(--sbkTypographyContentLargeScrBodyRegularSm);
                    }
                }
            `;
            if (!shadowRoot.querySelector('.sbk')) {
                shadowRoot.appendChild(styleElement);
            }
        }
    }
}